import lineGraphMultiAxis from './lineGraphMultiAxis';

export default lineGraphMultiAxis;
